import React from 'react';
import cx from 'classnames';
import { FormattedMessage } from 'react-intl';
import Img from 'components/Image';
import hexColoredSmall from 'utils/images/hex-colored-small.svg';
import WL from 'constants/whiteLabel';
import gs from 'pages/pages.module.css';
import s from 'pages/homeStyles.module.css';
import style from './HashrateS10.module.css';

const HashrateS10 = () => (
  <section className={cx(style.root, gs.content, s.hiveosContent)}>
    {WL.showHexImg ? <img alt="hex" className={cx(s.drop1, s.__oneSolution)} src={hexColoredSmall} /> : null}
    <div className={gs.backgroundHeader}>hashrate</div>
    <div className={cx(gs.wrapper, s.wrapper)}>
      <div className={gs.relative}>
        <div className={style.transfromToLeft}>
          <Img className={style.screen} src="hashrate_speed_s10.png" alt="hashrate" />
        </div>
      </div>
      <div className={style.text}>
        <h2><FormattedMessage id="HashrateS10.title" defaultMessage="Get up to 23.5TH/s" /></h2>
        <p className={gs.subheader}><FormattedMessage id="HashrateS10.caption1" defaultMessage="with standard PSU" /></p>
        <div><b>*<FormattedMessage id="HashrateS10.caption3" defaultMessage="Gain more hashrate than S9 with the same power consumption." /></b></div>
      </div>
    </div>
  </section>
)

export default HashrateS10;
